export default __webpack_public_path__ + "static/media/732.66007489.png";